import { NavMarker } from 'react-rhumb';
import Heading from '../../../components/Layouts/Heading';
import { useEffect, useState } from 'react';
import { SCREENS } from '../../../constants/Tracking';
import { MyLearningTabNavigation } from './MyLearningTabNavigation';
import useWootricSurvey from '../../../hooks/useWootricSurvey';
import UIDashboardPage from 'UIComponents/page/UIDashboardPage';
import { useSearchParamCatalogSearch } from '../../search';
// @ts-expect-error Could not find a declaration file for module
import PaginatedUICardGrid from '../../../containers/MyLearningPage/PaginatedUICardGrid';
import { MY_SAVED_ITEMS_PAGE_SIZE } from '../../savedItems';
import ApiError from '../../../components/Errors/ApiError';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { ShortCard } from '../../cards';
import TrackCardContainer from '../../../containers/TracksPage/TrackCardContainer';
import LessonCardContainer from '../../../components/LessonCard/LessonCardContainer';
import { safeSmoothScrollTo } from '../../../utils/utils';
import NoResultsError from '../../../components/Errors/NoResultsError';
import { useLocation } from 'react-router-dom';
import { MyLearningTabTypeToLearningContentTypeMapping, useMyLearningParams } from '..';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ResultsStatusBar from '../../../components/ResultsStatusBar';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
import { TopFilters } from '../../filters';
import { theme } from 'academy-common-lib/utils/Styling';
import ContentCardSkeleton from '../../../components/TrackCard/ContentCardSkeleton';
import UsageTracker from '../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MY_LEARNING_FILTERS = {
  all: [FILTER_TYPES.AWARD_TYPE, FILTER_TYPES.PROGRESS_STATUS, FILTER_TYPES.CONTENT_TYPE, FILTER_TYPES.SEARCH],
  'courses-and-lessons': [FILTER_TYPES.AWARD_TYPE, FILTER_TYPES.PROGRESS_STATUS, FILTER_TYPES.SEARCH],
  videos: [FILTER_TYPES.SEARCH]
};
const useMyLearningTab = () => {
  const {
    tab
  } = useMyLearningParams();
  const {
    tracksLessonsSearchQueryLoading: myLearningLoading,
    tracksLessonsSearchQueryError: myLearningError,
    tracksLessonsSearchQueryData: myLearningResults
  } = useSearchParamCatalogSearch({
    isPartnerPage: false,
    sortByDefault: true,
    context: 'INDIVIDUAL',
    contentTypes: MyLearningTabTypeToLearningContentTypeMapping[tab],
    status: ['IN_PROGRESS', 'COMPLETED']
  });
  return {
    myLearningResults,
    myLearningLoading,
    myLearningError,
    totalMyLearningResults: myLearningResults.length,
    tab
  };
};
export const MyLearningTabs = () => {
  useWootricSurvey('CSAT');
  const location = useLocation();
  const [countState, setCountState] = useState({
    endCard: 0,
    cardsTotal: 0,
    startCard: 0
  });
  const {
    myLearningResults,
    totalMyLearningResults,
    myLearningLoading,
    myLearningError,
    tab
  } = useMyLearningTab();
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: SCREENS.MY_LEARNING
    });
  }, []);
  const handlePageChange = () => {
    safeSmoothScrollTo(window, 0, 0);
  };
  const filters = MY_LEARNING_FILTERS[tab];
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "my-learning-page",
    children: [/*#__PURE__*/_jsx(Heading, {
      subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.heading.headingSubTitles.MY_LEARNING`
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.heading.headingTitles.MY_LEARNING`
      })
    }), /*#__PURE__*/_jsx(ResultsStatusBar, {
      cardsTotal: countState.cardsTotal,
      endCard: countState.endCard,
      mobileFilterTypes: tab !== 'videos' ? filters : undefined,
      startCard: countState.startCard
    }), /*#__PURE__*/_jsxs(UIDashboardPage, {
      headerComponent: null,
      mainSectionStyle: {
        backgroundColor: theme.colors.OLAF
      },
      children: [/*#__PURE__*/_jsx(MyLearningTabNavigation, {}), /*#__PURE__*/_jsx(TopFilters, {
        enabledFilters: filters,
        showClearButton: false,
        showLabel: tab !== 'videos'
      }), myLearningError ? /*#__PURE__*/_jsx(ApiError, {
        error: myLearningError,
        marker404: 'MYLEARNING_LISTING_API_404',
        markerDefault: 'MYLEARNING_LISTING_API_ERROR'
      }) : myLearningLoading || !myLearningResults ? /*#__PURE__*/_jsx(UILoadingSpinner, {
        grow: true,
        minHeight: 100
      }) : /*#__PURE__*/_jsx(NavMarker, {
        name: "MYLEARNING_LISTING_LOADED",
        children: myLearningResults.length ? /*#__PURE__*/_jsx(PaginatedUICardGrid, {
          limit: MY_SAVED_ITEMS_PAGE_SIZE,
          onCalculateContents: setCountState,
          onPageChange: handlePageChange,
          totalCount: totalMyLearningResults,
          children: myLearningResults.map(({
            id,
            type,
            language
          }, index) => {
            return type === 'SHORT_FORM_CONTENT' && language ? /*#__PURE__*/_jsx(ShortCard, {
              appearsIn: "my-learning",
              language: language,
              loadingState: /*#__PURE__*/_jsx(ContentCardSkeleton, {}),
              position: index + 1,
              shortId: id
            }, `short-${id}`) : type === 'TRACK' ? /*#__PURE__*/_jsx(TrackCardContainer, {
              appearsIn: "my-learning",
              language: language || undefined,
              loadingState: /*#__PURE__*/_jsx(ContentCardSkeleton, {}),
              position: index + 1,
              trackId: id
            }, `track-${id}`) : /*#__PURE__*/_jsx(LessonCardContainer, {
              appearsIn: "my-learning",
              language: language || undefined,
              lessonId: id,
              loadingState: /*#__PURE__*/_jsx(ContentCardSkeleton, {}),
              position: index + 1
            }, `lesson-${id}`);
          })
        }) : /*#__PURE__*/_jsx(NoResultsError, {
          resetLink: location.pathname
        })
      })]
    })]
  });
};